<template>
  <v-card class="hc__rounded-card">
    <v-card-title>
      <div class="hc__box-title py-4 pl-4">
        <p>Centro de ayuda</p>
        <h1 class="hc__blue-text headline">{{ subcategory.name }}</h1>
      </div>
    </v-card-title>

    <v-list v-for="(question, i) in subcategory.questions" :key="i"> 
      <v-list-tile
        :key="question.id"
        :to="`${$route.path}/${question.id}`"
        class="comment-list pl-3"
      >
        <v-list-tile-content>
          <div>
            {{ question.name }}
          </div>
        </v-list-tile-content>
        <v-list-tile-action>
          <img src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/chevron-right.svg" class="chevron-right" alt=""></img>
        </v-list-tile-action>
      </v-list-tile>
      
      <v-divider></v-divider>
    </v-list>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      subcategory: {}
    }
  },
  methods: {
    ...mapActions("helpcenter", ["fetchSubcategory"]),
    async getSubcategory() {
      const res = await this.fetchSubcategory(this.$route.params.subcategory)
      this.subcategory = res
      this.$emit("setBreadcrumbs", this.subcategory.breadcrumbs)
    }
  },
  created() {
    this.getSubcategory()
  },
}
</script>
<style lang="css">
.hc__rounded-card{
  border-radius: 0.5rem
}
.chevron-right{
  width: 40px;
  filter: invert(85%) sepia(92%) saturate(6513%) hue-rotate(117deg) brightness(96%) contrast(88%);
}
</style>